import { render, staticRenderFns } from "./originalsReceivedDialog.vue?vue&type=template&id=5a335de5&scoped=true"
import script from "./originalsReceivedDialog.vue?vue&type=script&lang=js"
export * from "./originalsReceivedDialog.vue?vue&type=script&lang=js"
import style0 from "./originalsReceivedDialog.vue?vue&type=style&index=0&id=5a335de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a335de5",
  null
  
)

export default component.exports